var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsentCapacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9512 49.5V24.75M4.70117 29.25V45C4.70117 47.4853 6.71589 49.5 9.20117 49.5H39.4102C42.7418 49.5 45.5751 47.0693 46.0817 43.7764L48.5048 28.0264C49.1339 23.9375 45.9703 20.25 41.8333 20.25H33.9512C32.7085 20.25 31.7012 19.2426 31.7012 18V10.0481C31.7012 6.98399 29.2172 4.5 26.153 4.5C25.4222 4.5 24.7599 4.93041 24.463 5.59828L16.545 23.4138C16.1839 24.2263 15.3781 24.75 14.489 24.75H9.20117C6.71589 24.75 4.70117 26.7647 4.70117 29.25Z",
    stroke: "#278DEC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsentCapacity);
export default __webpack_public_path__ + "static/media/ConsentCapacity.6997543bf5a674c1703e054135d19444.svg";
export { ForwardRef as ReactComponent };